<!-- Loader Overlay -->
<div *ngIf="isLoading$ | async" class="loader-overlay">
  <div class="loader-box">
    <div class="progress-text">{{ (progress$ | async) }}%</div>
    <div class="progress-bar">
      <div class="progress-fill" [style.width.%]="progress$ | async"></div>
    </div>
  </div>
</div>

<div class="layout-container">
  <app-header [componentName]="componentName"></app-header>
  <main class="main-content">
    <div class="row g-0">
      <div class="col-auto sidebar">
        <app-sidebar></app-sidebar>
      </div>
      <div class="col wrapper overflow-auto">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>
</div>
